import {
  CITIZENSHIP_TYPE_VALUES,
  DOCUMENT_TYPE,
  DOCUMENTS_BY_CITIZENSHIP
} from '../constants/citizenship';

export const getCitizenshipByDocumentType = documentType => {
  if (!documentType || !DOCUMENT_TYPE[documentType]) {
    return null;
  }

  const citizenship = Object.keys(DOCUMENTS_BY_CITIZENSHIP).find(key => {
    return DOCUMENTS_BY_CITIZENSHIP[key].includes(documentType);
  });

  if (citizenship) {
    return {
      type: citizenship,
      name: CITIZENSHIP_TYPE_VALUES[citizenship]
    };
  }

  return null;
};
